module.exports = __webpack_public_path__ + "media/images/claim_profile/search-73deee8395cab9733fdc1a1436f9170f.png";